import { ErrorMessage, Field, useFormikContext } from 'formik'
import React from 'react'
import { shouldDisplayError } from './formErrorComponent'

export const TextField = ( props )=>{
  const { name , placeholder, type, id, component} = props
  const {errors, touched} = useFormikContext();
  let isError = shouldDisplayError(errors,touched,name)
  let fieldType = 'text'
  if(type){
    fieldType = type;
  }

  return(
    <React.Fragment>
      <div className={'form-floating'}>
        <Field
          className={isError ? 'form-control error':'form-control'}
          id={id}
          name={name}
          placeholder={placeholder}
          component={component}
          type={fieldType}
        />
        <label htmlFor={id}>{placeholder}</label>
      </div>

      <ErrorMessage
        name={name}
        component="div"
        className="field-error"
      />
    </React.Fragment>
  )


}